module.exports = __webpack_public_path__ + "img/px-works.ab21bb57.png";